import { useEventListener } from "@vueuse/core";

export function useIntercom({ isIframe, iframeName }) {
  const listeners = [];
  const targetOrigin = "*";

  /**
   * Dispatch a message to all iframes and parent.
   * This allows bi-directional communication between the iframe and the parent.
   *
   * @param {Object} options
   * @param {String} options.type - type of the message
   * @param {String|} options.payload - payload of the message
   * @returns {void}
   */
  const dispatchMessage = isIframe ? dispatchMessageToParent : dispatchMessageToIframes;

  function dispatchMessageToParent(message) {
    window.parent.postMessage(message, targetOrigin);
  }

  function dispatchMessageToIframes(message) {
    const iframe = Array.from(window.frames).find(({ name }) => name === iframeName);
    iframe.postMessage(message, targetOrigin);
  }

  useEventListener(window, "message", handleMessage);

  function handleMessage(event) {
    const { type, payload } = event.data ?? {};

    listeners.forEach(({ event, listener }) => {
      if (event === type) {
        listener(payload);
      }
    });
  }

  function onMessage(event, listener) {
    listeners.push({ event, listener });
  }

  return {
    dispatchMessage,
    onMessage,
  };
}
